import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'run'
  },
  {
    path: 'run',
    loadComponent: () =>
      import( './components/embedded-run/embedded-run.component' ).then( ( m ) => m.EmbeddedRunComponent )
  },
  {
    path: 'error',
    loadComponent: () =>
      import( './components/embedded-error/embedded-error.component' ).then( ( m ) => m.EmbeddedErrorComponent )
  },
  {
    path: '**',
    redirectTo: 'error'
  }];

@NgModule( {
  imports: [RouterModule.forRoot( routes, {} )],
  exports: [RouterModule]
} )
export class AppRoutingModule { }


